import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const CaseHeader = ({ caseData, partner }) => {
  const navigate = useNavigate();

  const getStatusBadge = (status) => {
    const badges = {
      draft: 'bg-gray-100 text-gray-700',
      eingegangen: 'bg-blue-100 text-blue-700',
      in_pruefung: 'bg-indigo-100 text-indigo-700',
      rueckfrage_offen: 'bg-orange-100 text-orange-700',
      termin_ausstehend: 'bg-purple-100 text-purple-700',
      termin_geplant: 'bg-purple-200 text-purple-800',
      begutachtung_laeuft: 'bg-cyan-100 text-cyan-700',
      gutachten_in_erstellung: 'bg-yellow-100 text-yellow-700',
      gutachten_fertig: 'bg-teal-100 text-teal-700',
      abgeschlossen: 'bg-brand-green/10 text-brand-green'
    };
    return badges[status] || 'bg-gray-100 text-gray-600';
  };

  return (
    <div className="bg-black/90 backdrop-blur-md border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <button onClick={() => navigate('/admin/dashboard')} className="text-white hover:text-brand-green">
              <ArrowLeft className="w-5 h-5" />
            </button>
            <div>
              <h1 className="text-xl font-bold text-white">
                Fall: {caseData?.license_plate || caseData?.id?.slice(0, 8) || 'N/A'}
              </h1>
              {partner && (
                <p className="text-sm text-gray-400">{partner.company_name || partner.email}</p>
              )}
            </div>
          </div>
          <span className={`px-4 py-2 rounded-full text-sm font-semibold ${getStatusBadge(caseData?.status)}`}>
            {caseData?.status}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CaseHeader;
